<template>
  <section class="handoff bg-white dark:bg-slate-800" aria-labelledby="transicao-titulo">
    <div class="handoff-layout">
      <div>
        <div class="flex flex-wrap items-center gap-3 text-sm mb-8" :aria-label="`Etapa ${origem} concluída. Próxima etapa: ${destino}.`">
          <span class="flex items-center gap-2 text-green-700 dark:text-green-300">
            <svg class="w-5 h-5" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="m7 12 3 3 7-7"/></svg>
            {{ origem }}
          </span>
          <svg class="w-4 h-4 text-gray-400" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 6 6 6-6 6"/></svg>
          <span class="font-semibold text-primary dark:text-blue-300">{{ destino }}</span>
        </div>
        <h2 id="transicao-titulo" ref="titulo" tabindex="-1" class="handoff-title font-bold text-gray-900 dark:text-gray-100 outline-none">
          {{ titulo }}
        </h2>
        <p class="mt-6 text-xl sm:text-2xl font-semibold text-gray-900 dark:text-gray-100">Próxima etapa: {{ destino }}.</p>
        <p class="mt-3 text-base sm:text-lg text-gray-600 dark:text-gray-300 leading-relaxed max-w-lg">{{ descricao }}</p>
      </div>
      <img class="handoff-art" src="@/assets/transicao-procuradores.png" width="768" height="512" alt="" />
      <div class="handoff-actions">
        <p v-if="aviso" class="flex items-start gap-3 rounded-xl bg-blue-50 dark:bg-slate-900 p-4 text-sm sm:text-base text-primary dark:text-blue-200 leading-relaxed">
          <svg class="w-5 h-5 flex-shrink-0 mt-0.5" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 11v6M12 7v1"/></svg>
          <span>{{ aviso }}</span>
        </p>
        <p class="mt-6 text-sm text-gray-600 dark:text-gray-300">Você será direcionado automaticamente para {{ destino }}.</p>
      </div>
    </div>
    <div class="handoff-progress bg-gray-200 dark:bg-slate-600" role="progressbar" :aria-label="`Avançando para ${destino}`" aria-valuemin="0" aria-valuemax="100" :aria-valuenow="Math.round(progresso)">
      <div class="handoff-progress-fill bg-primary dark:bg-blue-500" :style="{ transform: `scaleX(${progresso / 100})` }"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TransicaoEntreAbas",
  props: {
    origem: { type: String, default: "Dados da Empresa" },
    destino: { type: String, default: "Procuradores" },
    titulo: { type: String, default: "Dados da empresa concluídos!" },
    descricao: { type: String, default: "Informe se alguém está autorizado a agir em nome da empresa." },
    aviso: { type: String, default: "Não possui procuradores? Você poderá continuar sem adicionar." },
  },
  emits: ["continuar"],
  data() {
    return { progresso: 0, temporizador: null, overflowAnterior: "" };
  },
  mounted() {
    this.overflowAnterior = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const inicio = Date.now();
    const tempoConfigurado = Number(process.env.VUE_APP_TRANSICAO_ENTRE_ABAS_TEMPO_SEGUNDOS) * 1000;
    const duracao = Number.isFinite(tempoConfigurado) && tempoConfigurado > 0 ? tempoConfigurado : 5000;
    this.temporizador = setInterval(() => {
      this.progresso = Math.min(100, ((Date.now() - inicio) / duracao) * 100);
      if (this.progresso >= 100) {
        clearInterval(this.temporizador);
        this.$emit("continuar");
      }
    }, 50);
    this.$nextTick(() => {
      this.$refs.titulo?.focus({ preventScroll: true });
    });
  },
  beforeUnmount() {
    clearInterval(this.temporizador);
    document.body.style.overflow = this.overflowAnterior;
  },
};
</script>

<style scoped>
.handoff { position: fixed; inset: 0; z-index: 10000; height: 100vh; height: 100dvh; overflow-y: auto; display: flex; padding: clamp(24px, 5vw, 80px); }
.handoff-layout { width: 100%; max-width: 1152px; margin: auto; display: grid; grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr); gap: 24px 40px; align-items: center; }
.handoff-title { font-size: clamp(2rem, 3.5vw, 3rem); line-height: 1.15; letter-spacing: -0.025em; text-wrap: balance; }
.handoff-art { width: 100%; height: auto; max-height: 320px; object-fit: contain; grid-column: 2; grid-row: 1 / 3; }
.handoff-actions { max-width: 580px; }
.handoff-progress { position: fixed; left: 0; right: 0; bottom: 0; height: 8px; }
.handoff-progress-fill { height: 100%; transform-origin: left; transition: transform 50ms linear; }
@media (max-width: 767px) {
  .handoff-layout { grid-template-columns: minmax(0, 1fr); gap: 24px; }
  .handoff-art { grid-column: 1; grid-row: auto; max-height: 230px; }
}
@media (prefers-reduced-motion: reduce) {
  .handoff-progress-fill { transition: none; }
}
</style>
